import { render } from "./yichangDate.vue?vue&type=template&id=77d833a6&scoped=true"
import script from "./yichangDate.vue?vue&type=script&lang=js"
export * from "./yichangDate.vue?vue&type=script&lang=js"

import "./yichangDate.vue?vue&type=style&index=0&id=77d833a6&lang=scss&scoped=true"

import exportComponent from "D:\\project\\digital-signage-cockpit-40\\防疫数据驾驶舱4.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77d833a6"]])

export default __exports__